export default "__VITE_ASSET__DFYtztKq__"